export const checkIsClientSide = () => {
  if (typeof window === 'undefined') {
    return false;
  }

  return true;
};
